import { useContext } from 'react';

import { AppleMusicPlayerContext } from './appleMusicPlayerContext';

export function useAppleMusicPlayer() {
  const value = useContext(AppleMusicPlayerContext);
  if (!value) {
    throw new Error('useAppleMusicPlayer must be used within AppleMusicPlayerProvider');
  }
  return value;
}
